var debounce = debounce || function(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE' && this.toggle.classList.contains('active')) {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
            this.unlockMobileMenuScroll();
          }
        }
      });
      this._stickyOffset = 0;
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
        this._stickyOffset = this.offsetTop;
        window.addEventListener('resize', debounce(() => {
          this._stickyOffset = this.offsetTop;
        }, 100), { passive: true });
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          this.unlockMobileMenuScroll();
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          this.lockMobileMenuScroll();
          setTimeout(() => {
            this.toggle.classList.add('active');
            this.openDefaultMobileMenu();
          });
        }
      });

      // Consolidated scroll listener with rAF coalescing
      this._scrollRafId = null;
      const onScroll = () => {
        if (this._scrollRafId) return;
        this._scrollRafId = requestAnimationFrame(() => {
          this._scrollRafId = null;
          this.setStickyClass();
          this.setHeaderOffset();
          this.setHeaderHeight();
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });

      onScroll();

      if (document.querySelector('.announcement-bar-section')) {
        this.setAnnouncementHeight();
        window.addEventListener('resize', debounce(() => {
          this.setAnnouncementHeight();
        }, 100), { passive: true });
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    lockMobileMenuScroll() {
      this._mobileMenuScrollY = window.scrollY;
      this._mobileMenuBodyTop = document.body.style.top;
      document.documentElement.classList.add('mobile-menu-open');
      document.body.classList.add('overflow-hidden', 'mobile-menu-open');
      document.body.style.top = `-${this._mobileMenuScrollY}px`;
    }
    unlockMobileMenuScroll() {
      const scrollY = this._mobileMenuScrollY ?? window.scrollY;
      document.documentElement.classList.remove('mobile-menu-open');
      document.body.classList.remove('overflow-hidden', 'mobile-menu-open');
      document.body.style.top = this._mobileMenuBodyTop || '';
      this._mobileMenuScrollY = null;
      this._mobileMenuBodyTop = null;
      window.scrollTo(0, scrollY);
    }
    openDefaultMobileMenu() {
      if (this.menu.dataset.openFirstItem !== 'true') {
        return;
      }

      const defaultDetails = this.menu.querySelector('.mobile-menu > li:first-child > details.link-container');
      const defaultTrigger = defaultDetails?.querySelector(':scope > summary .link-forward');

      if (!defaultTrigger) {
        return;
      }

      this.menu.querySelectorAll('details.link-container').forEach((detailsElement) => {
        detailsElement.classList.remove('menu-opening', 'submenu-open');
        detailsElement.removeAttribute('open');
      });

      defaultTrigger.click();

      defaultDetails
        .querySelectorAll(':scope > .sub-menu > li > details.link-container')
        .forEach((detailsElement, index) => {
          if (index < 2) {
            detailsElement.setAttribute('open', '');
          }
        });
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        this.classList.toggle('is-sticky', window.scrollY >= this._stickyOffset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      const parentLinks = this.menu.dataset.parentLinks === 'true';

      if (parentLinks) {
        event.preventDefault();
        const clickedArrow = event.target.closest('.link-forward');

        if (!clickedArrow) {
          const anchor = summaryElement.querySelector('a');
          if (anchor && anchor.href) {
            window.location.href = anchor.href;
            return;
          }
        }

        if (isOpen) {
          detailsElement.removeAttribute('open');
          return;
        }
        detailsElement.setAttribute('open', '');
      }

      // Hydrate deferred sub-menu on first open
      const tpl = detailsElement.querySelector(':scope > .mobile-menu-deferred');
      if (tpl) {
        detailsElement.appendChild(tpl.content);
        tpl.remove();
        detailsElement.querySelectorAll('summary').forEach(s => s.addEventListener('click', this.onSummaryClick.bind(this)));
        detailsElement.querySelectorAll('.parent-link-back--button').forEach(b => b.addEventListener('click', this.onCloseButtonClick.bind(this)));
      }

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    resizeSubMenus() {
      let updates = [];
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;
          updates.push({ el: sub_submenu.parentElement, needsLeft: total > window.innerWidth });
        });
      });
      updates.forEach(({ el, needsLeft }) => {
        el.classList.toggle('left-submenu', needsLeft);
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
